<template>
<file-layout @download="onDownload" :file-name="fileName" :show-header="isPublic" :can-download="isPublic" :allow-share="false">
    <!-- <div class="download">
      <div class="message-box">
        <div class="message">
          <img src="@/assets/h5/notfound.png" />
          <div class="text">
            <span>该文件不支持预览</span>
          </div>
          <div class="button-group">
            <button v-if="auth !== 'READ'" :class="buttonClass" @click="onDownload">
              {{ buttonText }}
            </button>
            <button v-if="isPcMode && isRp && isLogin" :class="buttonClass" @click="openAxure">
              直接打开
            </button>
          </div>
        </div>
      </div>
      <div class="empty"></div>
    </div> -->
    <div class="download-preview">
      <svg-icon :icon-class="fileIcon" class="zip-icon"></svg-icon>
      <div class="title">{{$t("该文件不支持预览#!!!#src/pages/H5/Cloud/components/DownloadView.vue_1")}}</div>
      <div class="tip" v-if="auth !== 'READ'">{{$t("您可以下载后查看#!!!#src/pages/H5/Cloud/components/DownloadView.vue_1")}}</div>
      <div>
        <button @click="openAxure" v-if="isPcMode && isRp && isLogin" class="preview-button common-button">{{$t("在线预览#!!!#src/pages/H5/Cloud/components/DownloadView.vue_1")}}        </button>
        <button @click="onDownload" v-if="auth !== 'READ'" class="download-button common-button">{{$t("下载到本地#!!!#src/pages/H5/Cloud/components/DownloadView.vue_1")}}        </button>
      </div>
    </div>
  </file-layout>
</template>

<script>
import { intl } from 'tci18n-vue2'
import cookies from "js-cookie";
import { mapState } from "vuex";
import FileLayout from "@/components/h5/Layout";
import crypto from "crypto";
import qs from "querystring";
import { fileImgName } from "@/utils/avatar";
import utils from "@/core/h5/utils";

export default {
  props: {
    rootId: {
      type: String
    },
    fileId: {
      type: String
    },
    metadata: {
      type: Object
    },
    isPublic: {
      type: Boolean
    },
    auth: {
      type: String
    },
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FileLayout
  },
  data() {
    return {
      link: null
    };
  },
  methods: {
    onDownload() {
      this.$emit("download", this.fileId);
    },

    getLink() {
      const key = `${this.rootId}-code`;
      const pass = cookies.get(key) || "";
      const inner = `${process.env.VUE_APP_INNERNET_URL}/file/preview/other/${this.fileId}`;
      // isPreview传true时使用新接口地址
      const outer = `${process.env.VUE_APP_INNERNET_URL}/public/preview/${this.fileId}?rootId=${this.rootId}&password=${pass}&isPreview=true`;
      return this.isPublic ? outer : inner;
    },

    async openAxure() {
      const token = cookies.get("token");
      const userId = cookies.get("userId");
      const spaceId = cookies.get("spaceId");
      const deviceId = cookies.get("deviceId");
      const baseUrl = process.env.VUE_APP_CLOUD_AXURE_URL;
      const options = {
        t: token,
        u: userId,
        s: spaceId,
        d: deviceId,
        f: this.fileId,
        v: this.metadata.createTime
      };
      const data = qs.stringify(options);
      const aesKey = Buffer.from("9vApxLk5G3PAsJrM", "utf8");
      const ivKey = Buffer.from("FnJL7EDzjqWjcaY9", "utf8");
      const cipher = crypto.createCipheriv("aes-128-cfb", aesKey, ivKey);
      let sign = cipher.update(data, "utf8", "base64");
      sign += cipher.final("base64");
      const url = `${baseUrl}?key=${encodeURIComponent(sign)}&v=2`;
      window.open(url);
    }
  },
  computed: {
    ...mapState({
      isPcMode: (state) => state.isPcMode
    }),

    buttonClass() {
      return this.isPcMode ? "pc-button" : "h5-button";
    },

    fileIcon() {
      return fileImgName(utils.getExt(this.metadata?.fileName || ""));
    },

    buttonText() {
      return this.isPcMode ? intl.$t("下载到本地#!!!#src/pages/H5/Cloud/components/DownloadView.vue_2") : intl.$t("下载查看#!!!#src/pages/H5/Cloud/components/DownloadView.vue_1");
    },

    fileName() {
      return this.metadata ? this.metadata?.fileName : "";
    },

    isRp() {
      return this.metadata?.fileName.includes("rp");
    }
  },

  mounted() {
    this.link = this.getLink();
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";

.download-preview {
  width: 464px;
  height: 297px;
  background: #ffffff;
  border-radius: 16px;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;

  .zip-icon {
    width: 72px;
    height: 72px;
    margin-bottom: 16px;
  }

  .title {
    font-family: "PingFang SC", sans-serif;
    font-weight: 600;
    font-size: 18px;
    color: #121317;
    letter-spacing: 0;
    margin-bottom: 8px;
  }

  .tip {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #646573;
    letter-spacing: 0;
    margin-bottom: 40px;
  }

  .common-button {
    width: 138px;
    height: 36px;
    border: 1px solid #e8e9ee;
    border-radius: 6px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
  }

  .preview-button {
    color: #222329;
    background: #ffffff;
    margin-right: 16px;
  }

  .download-button {
    color: #ffffff;
    background: #5c70ff;
  }
}

.download {
  height: 100%;
  display: flex;
  flex-direction: column;

  .message-box {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .message {
      text-align: center;

      img {
        width: 120px;
      }

      span {
        font-weight: 500;
        font-size: 17px;
        color: rgba(0, 0, 0, 0.3);
      }

      .button-group {
        display: flex;
        flex-flow: row;
      }

      .text {
        margin: 10px 0 30px 0;
      }

      .pc-button {
        @include pc-primary-button;
        width: 140px;
        height: 30px;
        margin-right: 5px;
      }

      .h5-button {
        @include h5-primary-button;
        width: 163px;
        height: 36px;
      }
    }

    .empty {
      height: 50%;
    }
  }
}
</style>
